export default __webpack_public_path__ + "static/house-demolition-e171a6569756e98aa1dc5b090e57658e.jpg";